import { Component, AfterViewInit, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbPanelChangeEvent, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { firebase } from './../../tools/tools';

@Component({
  selector: 'ap-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements AfterViewInit, OnInit {
	name:string;
  user:any;
  	public config: PerfectScrollbarConfigInterface = {};
  	constructor(private modalService: NgbModal) {

    }

    ngOnInit(){
      this.user = firebase.auth().currentUser;
    }

    ngAfterViewInit() {

        var set = function() {
            var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
            var topOffset = 0;
            if (width < 1170) {
                $("#main-wrapper").addClass("mini-sidebar");
            } else {
                $("#main-wrapper").removeClass("mini-sidebar");
            }
        };
        $(window).ready(set);
        $(window).on("resize", set);


        $(".search-box a, .search-box .app-search .srh-btn").on('click', function () {
            $(".app-search").toggle(200);
        });


        $("body").trigger("resize");
    }

    closeSession(){
      firebase.auth().signOut().then(function() {
        window.location.reload();
      }).catch(function(error) {
      // An error happened.
    });
  }
}
